import { render, staticRenderFns } from "./ExpeditedFormButton.vue?vue&type=template&id=35a50470&scoped=true&"
import script from "./ExpeditedFormButton.vue?vue&type=script&lang=js&"
export * from "./ExpeditedFormButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpeditedFormButton.vue?vue&type=style&index=0&id=35a50470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a50470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a50470')) {
      api.createRecord('35a50470', component.options)
    } else {
      api.reload('35a50470', component.options)
    }
    module.hot.accept("./ExpeditedFormButton.vue?vue&type=template&id=35a50470&scoped=true&", function () {
      api.rerender('35a50470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/RequestHelpers/ExpeditedFormButton.vue"
export default component.exports